// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/first-steps.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const firstSteps: Score = {
  slug: "first-steps",
  n: 1,
  title: "First Steps",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "C",
  fifths: 0,
  time: [4, 4],
  tempo: 92,
  staves: 1,
  clefs: ["treble"],
  bars: 8,
  barQuarters: 4.0,
  lowest: 59,
  highest: 67,
  hasLyrics: false,
  jasonNote: "Here's a short piece I wrote using the white notes on the Piano \u2014 C D E F G as well as B below middle C. Watch the second last bar where you have to cross over your thumb.",
  teaches: ["five-finger position C to G", "B below middle C", "thumb cross-over in the second-last bar"],
  art: "/sight-reading/art/first-steps.jpg",
  artRights: "stock",
  background: "/sight-reading/bg/first-steps.jpg",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 2.0, midi: 67, pitch: "G4", d: "half" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 1, hand: "rh", start: 3.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 2, hand: "rh", start: 4.0, dur: 2.0, midi: 65, pitch: "F4", d: "half" },
    { bar: 2, hand: "rh", start: 6.0, dur: 2.0, midi: 64, pitch: "E4", d: "half" },
    { bar: 3, hand: "rh", start: 8.0, dur: 2.0, midi: 60, pitch: "C4", d: "half" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 4, hand: "rh", start: 12.0, dur: 4.0, midi: 62, pitch: "D4", d: "whole" },
    { bar: 5, hand: "rh", start: 16.0, dur: 2.0, midi: 67, pitch: "G4", d: "half" },
    { bar: 5, hand: "rh", start: 18.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 5, hand: "rh", start: 19.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 6, hand: "rh", start: 20.0, dur: 2.0, midi: 65, pitch: "F4", d: "half" },
    { bar: 6, hand: "rh", start: 22.0, dur: 2.0, midi: 64, pitch: "E4", d: "half" },
    { bar: 7, hand: "rh", start: 24.0, dur: 2.0, midi: 62, pitch: "D4", d: "half" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 7, hand: "rh", start: 27.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 60, pitch: "C4", d: "whole" },
  ],
};
